import React, { PropsWithChildren, useEffect } from "react";
import "./Layout.css";
import { Layout, ConfigProvider } from "antd";
import { useLocation } from 'react-router-dom';
import NavMenu from "./NavMenu";
import Header from "./Header";

const SystemManageLayout = (props: PropsWithChildren) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: "#fff",
            headerHeight: 60,
            headerPadding: "0 20px 0 30px",
          },
        },
      }}
    >
      <Layout className="system-layout">
        <Header />
        <Layout>
          <Layout.Sider width={240} className="system-layout-slider">
            <NavMenu />
          </Layout.Sider>
          <Layout.Content className="system-layout-content">
            {props.children}
          </Layout.Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default SystemManageLayout;